<template>
  <div id="app" :class="{'appjctheatre':$store.state.roomlive.playstauts == 'theatre'}">
    <pageheader v-if="$route.meta.isHeader" />
    <router-view />
  </div>
</template>

<script>
// 导入上传图片组件
import pageheader from '@/components/pageheader.vue'
// import { setLanguage } from '@/i18n'

const langMetaConfig = {
  'vi': {
    title: 'Đầu livestream BLV',
    keywords: 'Đầu livestream BLV',
    description: 'Đầu livestream BLV'
  },
  'zh-CN': {
    title: '主播开播端',
    keywords: '主播开播端',
    description: '主播开播端'
  },
  'en': {
    title: 'Broadcaster Studio',
    keywords: 'Broadcaster Studio',
    description: 'Broadcaster Studio'
  }
}

export default {
  name: 'App',
  components: {
    pageheader,
  },
  metaInfo() {
    const lang = process.env.VUE_APP_LANG || 'zh-CN'
    const metaConfig = langMetaConfig[lang] || langMetaConfig['zh-CN']
    return {
      title: metaConfig.title,
      meta: [
        { name: 'keywords', content: metaConfig.keywords },
        { name: 'description', content: metaConfig.description }
      ]
    }
  },
  created() {},
  mounted() {
    // setLanguage('zh-CN')

    document.oncontextmenu = function () {
      return false
    }
  },
}
</script>

<style lang="less">
#app {
  width: 100%;
  margin: 0 auto;
  height: 100%;
  min-height: 810px;
  // overflow: auto;
  background-color: #f8f9fb;
}
.appjctheatre {
  height: 100vh !important;
  overflow: hidden;
  &::-webkit-scrollbar {
    width: 0px !important;
  }
}
// 书写外层
::-webkit-scrollbar {
  width: 5px;
  height: 2px;
  border-radius: 10px; /*外层轨道*/
}
// 书写内层
::-webkit-scrollbar-thumb {
  display: block;
  height: 20px;
  width: 6px;
  margin: 0 auto;
  border-radius: 10px;
  background: #ebf0fb; /*内层轨道*/
}
::-webkit-scrollbar-thumb:hover {
  background: #ebf0fb;
}
.el-message {
  min-width: 110px !important;
  top: 152px !important;
}
</style>
